// extracted by mini-css-extract-plugin
export default {"alert":"v1BHFqibveNd3Gax2xtf","bold":"Sw7PgvaVaqhez5qiPlqE","underline":"uKc2fgbbh5lyBXYxwpoI","link":"UWwbk67TXQmCmRnucBxQ","close_button":"Cp8yrDQeoY1xLIjqhZhc"};